import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FCEBE4",
  d: "M8 3.5h11v17H8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2632C",
  fillRule: "evenodd",
  d: "M4.001 3.7a.7.7 0 0 1 .7-.7h14.6a.7.7 0 0 1 .7.7v16.6a.7.7 0 0 1-.7.7h-14.6a.7.7 0 0 1-.7-.7v-3.313h-.2a.7.7 0 1 1 0-1.4H4v-2.662h-.2a.7.7 0 1 1 0-1.4H4V8.862h-.2a.7.7 0 1 1 0-1.4H4zm1.4 5.162h.1a.7.7 0 1 0 0-1.4h-.1V4.4h2v15.2h-2v-2.612h.1a.7.7 0 1 0 0-1.4h-.1v-2.662h.1a.7.7 0 1 0 0-1.4h-.1zm3.4 10.737h9.8V4.4h-9.8zm2.3-11.437a.7.7 0 0 1 .7-.7h3.6a.7.7 0 1 1 0 1.4h-3.6a.7.7 0 0 1-.7-.7m0 4.063a.7.7 0 0 1 .7-.7h3.6a.7.7 0 1 1 0 1.4h-3.6a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=ReportsColorIcon24.js.map